import { useMemo } from 'react';
import JSON_DATA_HEADER from '../data/header.json';

export const useHeaderTaxas = ({ administrador }) => {
    return useMemo(() => {
        return JSON_DATA_HEADER;
    }, []);
};